<template>
  <div>
    {{ Title }}
    <b-row no-gutters>
      <b-col>
        <b-progress :max="100" height="1.5rem">
          <b-progress-bar
            :style="{ 'background-color': getColor(Score) }"
            :value="Score"
          ></b-progress-bar>
        </b-progress>
      </b-col>
      <b-col sm="auto">
        <span class="pl-3">{{ Math.round(Score) }}%</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    Title: String,
    Score: Number,
    ColorRange: Array,
  },
  methods: {
    getColor(value) {
      if (!this.ColorRange) return null;

      return this.ColorRange.find(
        (thres) => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    },
  },
};
</script>

<style>
</style>